import { INCREMENT, DECREMENT } from "./actionTypes";

export const increment = (value) => {
	return {
		type: INCREMENT,
		payload: {
			id: value,
		},
	};
};

export const decrement = (value) => {
	return {
		type: DECREMENT,
		payload: {
			id: value,
		},
	};
};
